
import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="py-20 topo-cta-bg relative">
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          Ready to Talk About Your Operation?
        </h2>
        <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto font-light">
          No sales pitch. Just a straightforward conversation about your land, your challenges, and whether our services make sense for you.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="/#contact"
            className="inline-block bg-emerald-700 hover:bg-emerald-600 text-white font-bold px-8 py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            Start a Conversation
          </a>
          <Link
            to="/case-studies"
            className="inline-block bg-transparent border-2 border-white text-white hover:bg-white hover:text-emerald-900 font-bold px-8 py-3.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
          >
            View Case Studies
          </Link>
        </div>
      </div>
    </section>
  );
}
